import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import PageLoader from "@/components/PageLoader";

const Dashboard = lazy(() =>
  import(/*webpackChunkName:'DashboardPage'*/ "@/pages/Dashboard")
);
const Admin = lazy(() =>
  import(/*webpackChunkName:'AdminPage'*/ "@/pages/Admin")
);

const Customer = lazy(() =>
  import(/*webpackChunkName:'CustomerPage'*/ "@/pages/Customer")
);

const Dms = lazy(() =>
  import(/*webpackChunkName:'DmsPage'*/ "@/pages/Dms")
);
const Project = lazy(() =>
  import(/*webpackChunkName:'ProjectPage'*/ "@/pages/Project")
);

const ProjectView = lazy(() =>
  import(/*webpackChunkName:'ProjectViewPage'*/ "@/pages/ProjectView")
);
const Alert = lazy(() =>
  import(/*webpackChunkName:'AlertPage'*/ "@/pages/Alert")
);
const Firmware = lazy(() =>
  import(/*webpackChunkName:'FirmwarePage'*/ "@/pages/Firmware")
);
const Cdcycle = lazy(() =>
  import(/*webpackChunkName:'CdcyclePage'*/ "@/pages/Cdcycle")
);
const User = lazy(() =>
  import(/*webpackChunkName:'UserPage'*/ "@/pages/User")
);

const SelectCustomer = lazy(() =>
  import(/*webpackChunkName:'SelectCustomerPage'*/ "@/pages/SelectCustomer")
);

const Lead = lazy(() => import(/*webpackChunkName:'LeadPage'*/ "@/pages/Lead"));
const Product = lazy(() =>
  import(/*webpackChunkName:'ProductPage'*/ "@/pages/Product")
);

const Logout = lazy(() =>
  import(/*webpackChunkName:'LogoutPage'*/ "@/pages/Logout")
);
const NotFound = lazy(() =>
  import(/*webpackChunkName:'NotFoundPage'*/ "@/pages/NotFound")
);
const Settings = lazy(() =>
  import(/*webpackChunkName:'SettingsPage'*/ "@/pages/Settings")
);
const Calibration = lazy(() =>
  import(/*webpackChunkName:'CalibrationPage'*/ "@/pages/Calibration")
);
export default function AppRouter() {
  const location = useLocation();
  return (
    <Suspense fallback={<PageLoader />}>
      <AnimatePresence exitBeforeEnter initial={false}>
        <Switch location={location} key={location.pathname}>
          <PrivateRoute path="/" component={Dashboard} exact />
          <PrivateRoute component={Dms} path="/dms" exact />
          <PrivateRoute component={Customer} path="/customer" exact />
          <PrivateRoute component={ProjectView} path="/projectview" exact />
          <PrivateRoute component={Project} path="/project" exact />
          <PrivateRoute component={User} path="/user" exact />
          <PrivateRoute
            component={SelectCustomer}
            path="/selectcustomer"
            exact
          />
          <PrivateRoute component={Lead} path="/lead" exact />
          <PrivateRoute component={Product} path="/product" exact />
          <PrivateRoute component={Admin} path="/admin" exact />
          <PrivateRoute component={Alert} path="/alert" exact />
          <PrivateRoute component={Firmware} path="/firmware" exact />
          <PrivateRoute component={Cdcycle} path="/cdcycle" exact />
          <PrivateRoute component={Settings} path="/settings" exact />
                    <PrivateRoute component={Calibration} path="/calibration" exact />
          <PrivateRoute component={Logout} path="/logout" exact />
          <PublicRoute path="/login" render={() => <Redirect to="/" />} />
          <Route
            path="*"
            component={NotFound}
            render={() => <Redirect to="/notfound" />}
          />
        </Switch>
      </AnimatePresence>
    </Suspense>
  );
}

